module.exports = __webpack_public_path__ + "static/media/check-double.1678bb21.svg";